

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import "./global.css";
import App from "./App";
import AppApproval from "./AppApproval";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./AuthContext";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(document.getElementById("root"));

const currentPath = window.location.pathname;
const skipPaths = ["/Approve", "/thankyou"];

// const shouldSkipConfig = skipPaths.includes(currentPath);
const shouldSkipConfig = skipPaths.some(path => currentPath.startsWith(path));

root.render(
  shouldSkipConfig ? (
    <AuthProvider>
      <AppApproval />
    </AuthProvider>
  ) : (
    <AuthProvider>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </AuthProvider>
  )
);

reportWebVitals();



